import { createSlice } from "@reduxjs/toolkit";

const loadCartFromLocalStorage = () => {
    try {
        const cart = localStorage.getItem("cart");
        return cart ? JSON.parse(cart) : [];
    } catch (error) {
        console.error("Error retrieving cart: ", error);
        return [];
    }
};

const loadIsFullFromLocalStorage = () => {
    try {
        const isFull = localStorage.getItem("isFull");
        return isFull ? JSON.parse(isFull) : false;
    } catch (error) {
        console.error("Error retrieving cart full state: ", error);
        return false;
    }
};

const saveCartToLocalStorage = (cart, isFull) => {
    try {
        localStorage.setItem("cart", JSON.stringify(cart));
        localStorage.setItem("isFull", JSON.stringify(isFull));
    } catch (error) {
        console.error("Error saving cart: ", error);
    }
};

const MAX_ITEMS = 5;

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        items: loadCartFromLocalStorage(),
        isFull: loadIsFullFromLocalStorage(),
    },
    reducers: {
        addItem: (state, { payload }) => {
            if (state.items.length < MAX_ITEMS) {
                const existingItem = state.items.find((item) => item.globalAssetId === payload.globalAssetId);
                if (existingItem) {
                    return;
                }

                state.items.push(payload);
                state.isFull = state.items.length === MAX_ITEMS;
                saveCartToLocalStorage(state.items, state.isFull);
            }
        },
        removeItem: (state, { payload }) => {
            state.items = state.items.filter(item => item.globalAssetId !== payload);
            state.isFull = state.items.length === MAX_ITEMS;
            saveCartToLocalStorage(state.items, state.isFull);
        },
        clearCart: (state) => {
            state.items = [];
            state.isFull = false;
            saveCartToLocalStorage(state.items, state.isFull);
        }
    }
});

export const {
    addItem,
    removeItem,
    clearCart
} = cartSlice.actions;
export default cartSlice.reducer;